module.exports = __webpack_public_path__ + "img/zx-bg.3a788148.jpg";